import React from "react";
import { Rocket, Building2, Globe2, TrendingUp, Users } from "lucide-react";
import { motion } from "framer-motion";

const SupportFunctions = () => {
  return (
    <section className="bg-white py-16 px-6 relative">
      <div className="container mx-auto max-w-6xl text-left">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h5 className="text-[#4FB1FF] text-center uppercase font-semibold tracking-wide mb-2">
            Support Functions
          </h5>
          <h2 className="text-5xl md:text-6xl font-Agatho_Regular text-center   font-bold text-[#0B1D33] mb-4">
            Empowering Businesses at Every Stage
          </h2>
          <p className="text-gray-600 leading-relaxed text-center  mb-12 text-base">
            <b>Indo European Business Council</b> provides a flexible support ecosystem
            for startups, SMEs, and corporates to thrive globally.
          </p>
     
        </motion.div>

        {/* Support Sections */}
        <div className="grid md:grid-cols-2 gap-8">
          {/* Startups & SMEs */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="flex flex-col md:flex-row items-center bg-gradient-to-br from-[#E3F4FF] to-[#F7FAFF] rounded-xl shadow-md p-6 hover:shadow-lg transition"
          >
            <div className="flex-shrink-0 bg-white rounded-full p-4 shadow-md md:mr-6 mb-4 md:mb-0 flex items-center justify-center">
              <img
                src="/HomePage/icons/startup.png"
                alt="Startup Icon"
                style={{ width: 40, height: 40 }}
              />
            </div>
      
            <div className="flex-1">
              <h3 className="text-xl md:text-2xl font-Agatho_Regular font-bold text-[#0B1D33] mb-1">
                Startups & SMEs
              </h3>
              <h4 className="text-[#4FB1FF] font-medium mb-3 text-base md:text-base">
                Innovation, Agility & Global Integration
              </h4>
              <ul className="list-disc list-inside text-gray-600 text-base space-y-1">
                <li>Business Development & Market Entry Support</li>
                <li>Capital & Funding Readiness</li>
                <li>Trade Facilitation & B2B Matchmaking</li>
                <li>Digital Enablement & Marketing Guidance</li>
              </ul>
            </div>
          </motion.div>

          {/* Large Corporates */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="flex flex-col md:flex-row items-center bg-gradient-to-br from-[#F3F7FF] to-[#E8F1FF] rounded-xl shadow-md p-6 hover:shadow-lg transition"
          >
            <div className="flex-shrink-0 bg-white rounded-full p-4 shadow-md md:mr-6 mb-4 md:mb-0 flex items-center justify-center">
              <img
                src="/HomePage/icons/corporation.png"
                alt="Corporation Icon"
                style={{ width: 40, height: 40 }}
              />
            </div>
      
            <div className="flex-1">
              <h3 className="text-xl md:text-2xl font-Agatho_Regular font-bold text-[#0B1D33] mb-1">
                Large Corporates
              </h3>
              <h4 className="text-[#4FB1FF] font-medium mb-3 text-base md:text-base">
                Strategic Depth & Global Reach
              </h4>
              <ul className="list-disc list-inside text-gray-600 text-base space-y-1">
                <li>Executive Advisory & Leadership Dialogues</li>
                <li>Global Expansion & Market Entry</li>
                <li>Industry Intelligence & Market Insights</li>
                <li>Workforce Mobility & Compliance Support</li>
              </ul>
            </div>
          </motion.div>
        </div>

        {/* Final Statement */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="mt-16 bg-[#F7FAFF] p-8 rounded-xl shadow-md"
        >
          {/* <Globe2 className="mx-auto text-[#4FB1FF] mb-3" size={40} /> */}
          <h3 className="text-3xl font-bold text-[#0B1D33] font-Agatho_Regular text-center  mb-2">
            A Partner for the Long Term
          </h3>
          <p className="text-gray-600 text-base leading-relaxed text-center  mb-4">
            <strong>Indo European Business Council</strong> delivers insight, foresight, and
            continuity for startups and corporates alike, ensuring resilient and
            globally aligned growth.
          </p>
     
          <div className="flex flex-wrap justify-center gap-4 text-[#0B1D33] font-medium text-base">
            <span className="flex items-center gap-1">
              <TrendingUp className="text-[#4FB1FF]" size={16} /> Anticipate
              Challenges
            </span>
            <span className="flex items-center gap-1">
              <Users className="text-[#4FB1FF]" size={16} /> Foster Ecosystems
            </span>
            <span className="flex items-center gap-1">
              <Building2 className="text-[#4FB1FF]" size={16} /> Translate
              Policy into Growth
            </span>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default SupportFunctions;
